import { FunctionComponent, useEffect } from 'react';
import { useAnalyticsService } from 'app/components/analytics/AnalyticsServiceProvider';
import { useAuthUser } from 'app/components/auth/AuthUserContext';
import { useBrand } from 'app/components/OrganizationContext';
import { isStaffMember, isTeacher } from 'app/models/auth/selectors';
import { GA4_ALL_SITE_GOOGLE_ANALYTICS_ID } from 'app/services/analytics/GoogleAnalytics';
import { getLocalClientRelease } from 'app/utils/clientVersion';
import { List } from 'immutable';
import { useHistoryLocation } from 'app/components/router/History';
import { AnalyticsPlatform } from 'app/services/analytics/AnalyticsService';

/**
 * This component is necessary instead of having all of the set up in the AnalyticsService
 */
const AnalyticsServiceConfigurator: FunctionComponent = () => {
  const analyticsService = useAnalyticsService();
  const user = useAuthUser();
  const userId = user?.id;
  const { id: brandId, analyticsIds, organization } = useBrand();
  const location = useHistoryLocation();

  const userRole = !user ? 'Anonymous User' : isStaffMember(user) ? 'Staff' : isTeacher(user) ? 'Teacher' : 'Student';

  useEffect(() => {
    const allAnalyticsIds = List([GA4_ALL_SITE_GOOGLE_ANALYTICS_ID]).concat(analyticsIds);

    analyticsService?.init(
      [{
        platform: AnalyticsPlatform.GTAG,
        trackingIds: allAnalyticsIds,
      }],
    );
  }, [analyticsService, analyticsIds]);

  useEffect(() => {
    analyticsService?.identifyUser(
      userId,
      {
        userRole,
        organization,
        brand: brandId,
        clientRelease: getLocalClientRelease(),
      },
    );
  }, [userId, brandId, organization, userRole, analyticsService]);

  useEffect(() => {
    analyticsService?.trackPage(`${location.pathname}${location.hash}${location.search}`);
  }, [location.pathname, location.hash, location.search, analyticsService]);

  return null;
};

export default AnalyticsServiceConfigurator;
